import { Component, OnDestroy,  OnInit, ViewChild, Input, Output, EventEmitter, NgZone, ChangeDetectorRef } from '@angular/core';
import { CommonService, PageService, SpinnerService} from '../../../services/service.index';
import { MessagesService } from '../../../services/common/messages.service';
import { SafeUrl } from '@angular/platform-browser';
import { ColorAdjustmentUtils } from '../../utilities/color-adjustment.utils';
import { AuthService } from 'src/app/models/auth/_services/auth.service';
import { UserModel } from 'src/app/models/auth/_models/user.model';
import { BehaviorSubject, Observable, Subscription, interval } from 'rxjs';
import { MainHTTPService } from 'src/app/services/main-http/main-http.service';
import { Page } from 'src/app/models/page.model';
import { MicroapplicationService } from 'src/app/services/microapplications/_services/microapplication.service';
import { MainModel } from 'src/app/models/auth/_models/main-model';
import { Link } from 'src/app/models/menu';
import { ConfigService } from 'src/app/services/config.service';



@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit, OnDestroy {

  firstName : string = '';
  Name : string = '';
  tokenOph: any;
  paginasOpenOph: number = 0;
  listProcessAdpro: any[] = [];
  Linkdata: Link[]= [];
  selectProcess: any;
  codProg: any;
  imageSource: SafeUrl = "";
  pagopheliaDis: boolean = false;
  private sessionData = JSON.parse(sessionStorage.getItem('sessionData') as any);
  private historisession = JSON.parse(sessionStorage.getItem('listHisotrial') as any);
  public empresaLista: any = {};
  private sub!: Subscription;
  @Input() filtroListaEmpresaBarraBones: boolean | undefined;
  @Output() newRegister: EventEmitter<any> = new EventEmitter();
  @Output() eventAgregar: EventEmitter<any> = new EventEmitter();
  @Output() showTableResultEvent: EventEmitter<any> = new EventEmitter();
  @Output() closet = new EventEmitter<any>();
  @ViewChild("iframe") iframe: any;  


  showTabla: any;
  reloadQbe: boolean | undefined;
  main: BehaviorSubject<MainModel[]> = new BehaviorSubject<MainModel[]>([]);
  user$: Observable<UserModel>;   
  delay = (ms: number) => new Promise(res => setTimeout(res, ms));
  userdata: any;
  chores$ = new BehaviorSubject<any>(0);
  chores:any;

  intervalId: any;
  company: string;
  token: any;
  pagesSe :Page[] = [];
  username: any;
isSidebarCollapsed: boolean=false;
  isSidebarCollapsedtemas: boolean;
  isSidebarCollapsedFavorito: boolean;
  isSidebarCollapsedRecent: boolean;
  usercode: any;

  // @HostListener('window:storage')
  // onStorageChange() {
  
  //   if(localStorage.getItem('CerrarSesion')){
  //     this.logOut();
  //   }    
  // }

  
  constructor(  private cdr: ChangeDetectorRef,private ngZone: NgZone,private microapps: MicroapplicationService,private _spinnerService: SpinnerService,private mainHTTPService:MainHTTPService,private _commonService: CommonService, private messagesService: MessagesService, 
              private _pageService: PageService, private config:ConfigService,
              private auth: AuthService            
                   
              ) {

   }

  async ngOnInit(): Promise<void> {     
 
    this.user$ = this.auth.currentUserSubject.asObservable();
     let userty = this.user$ ;
    // // this.userdata= userty.source.value;

    await this.delay(600);
    this._pageService.eventOpenMenu.subscribe(e=>{
      this.openMenu()
    })

   
    this.company = this.sessionData.selectedCompany.code;
    this.username = this.sessionData.username;
    this.usercode = this.sessionData.accountCode;
 

    this.getchores(); // primera carga
    this.sub = interval(4000).subscribe(() => {
      this.ngZone.run(() => this.getchores());
    });


  }

 

  ngOnDestroy(): void {

    if (this.sub) this.sub.unsubscribe();

    
    window.removeEventListener("message", (event) => {
    });
      const defaultSecondaryColor = getComputedStyle(document.documentElement).getPropertyValue('--secondary-color').trim();
      const darkenColor = 0.08; // Ejemplo de valor de ajuste
      const adjustedColor = ColorAdjustmentUtils.adjustColorDarkness(defaultSecondaryColor, darkenColor);
      
      // Asignar el valor a --secondary-color-adjusted en lugar de --secondary-color
      document.documentElement.style.setProperty('--secondary-color-adjusted', adjustedColor);


     
  }

  logOut(): void {
    try {
     
      const keysToRemove = [
        'auth_token',
        'licensemessageerror',
        'login_option',
        'logout',
        'Pages',
        'sessionData',
     
      ];
  
      keysToRemove.forEach((key) => {
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
      });
  

      localStorage.setItem('logout', 'S');
  
  
    } catch (error) {
      console.error('Error durante logOut:', error);
    }
  }
  

  

  salir() {    
    this.logOut();
    this.auth.logoutSession();
    localStorage.setItem('', 'true');      
  }

  Base64toBlob(ext: any, dataURI: any) {
    ext = (ext + '').toLowerCase();
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    let blob: any;
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }    
    blob = new Blob([int8Array], { type: 'application/pdf' });
    return blob;
  }

  OpenMas = () => { 
 
this.isSidebarCollapsed=true;
    
  } 

  OpenRec= () => { 
 
    this.isSidebarCollapsedRecent=true; 
        
      } 

  OpenFav = () => { 
 
    this.isSidebarCollapsedFavorito=true; 
      } 

  Opentemas = () => { 
    this.isSidebarCollapsedtemas=true;
        
      } 

      closetemas() {

        const body = document.querySelector('body');
        const header = document.querySelector('.sp-offcanvas-panel'); 
        if (body && header) {
          body.classList.remove('sp-offcanvas-panel--on');
          header.classList.remove('sp-offcanvas-panel--on');
          document.querySelectorAll('.sp-offcanvas-panel-overlay').forEach(e=> e.remove());
        }
        this.isSidebarCollapsedtemas=false;
      } 

      closemas() {

        const body = document.querySelector('body');
        const header = document.querySelector('.sp-offcanvas-panel'); 
        if (body && header) {
          body.classList.remove('sp-offcanvas-panel--on');
          header.classList.remove('sp-offcanvas-panel--on');
          document.querySelectorAll('.sp-offcanvas-panel-overlay').forEach(e=> e.remove());
        }
        this.isSidebarCollapsed=false;
      }

  close() {

    const body = document.querySelector('body');
    const header = document.querySelector('.sp-offcanvas-panel'); 
    if (body && header) {
      body.classList.remove('sp-offcanvas-panel--on');
      header.classList.remove('sp-offcanvas-panel--on');
      document.querySelectorAll('.sp-offcanvas-panel-overlay').forEach(e=> e.remove());
    }
 
    // this.isSidebarCollapsedFavorito=false;
    this.isSidebarCollapsedRecent=false
  }    

  closeFav() {

    const body = document.querySelector('body');
    const header = document.querySelector('.sp-offcanvas-panel'); 
    if (body && header) {
      body.classList.remove('sp-offcanvas-panel--on');
      header.classList.remove('sp-offcanvas-panel--on');
      document.querySelectorAll('.sp-offcanvas-panel-overlay').forEach(e=> e.remove());
    }
 
    this.isSidebarCollapsedFavorito=false;
  }  



  log(e: any){
    console.log(e);
    
  }


  openMenu(){
    let div: any = document.querySelector('#combo-empresa');
    let back: any = document.querySelector('#background');
    div.classList.toggle('d-t-none');
    back.classList.toggle('d-t-block');
    document.querySelector(".side-mini-custom")?.classList.remove(".side-mini-custom")
    document.body.classList.remove("sp-aside--minimize")
  }

  getchores() {
    this.mainHTTPService.getchores(this.username, this.company).subscribe(resp => {
      this.chores = resp.result;
      this.cdr.markForCheck();
    });
  }

  
  gettask(){
    this._spinnerService.loading();
    this.mainHTTPService.getFilter("SWFSVRCN").subscribe(resp => {
      if (resp.isSuccessful) {
        this.main.next(resp.result);
        this.microapps.GetMicroApplicationsById(resp.result[0].microApplicationId).subscribe(resp => {
          if (resp.isSuccessful) {

            this.token = this.auth.getAuthFromLocalStorage().accessToken;
            const page: Page = {
              codProg: "Tareas",
              name: "Tareas",
              idForm: null,
              id: 453,
              url: null,
              cambiarUrl: true,
              // typeForm: itemObj.url.includes('adpro') ? 'adpro' : 'maestro'
              typeForm: 'maestro',
              lisnk:null
            };
            this.removeClass('open-item');
            this._spinnerService.close();
          
              page.url=resp.result.url + '?companyCode=' + this.company + '&token=' + this.token + '&mode=browser';
              this._pageService.generarPage(page);

          }
        });
      }
      else { }
    });
  }

  removeClass = (classs: string) => {
    let nodes = document.querySelectorAll(`.${classs}`);
    nodes.forEach(node => {
      node.classList.remove(classs)
    })
  }

  getFontSize(chores: number): string {
    if (chores >= 100) {
        return '50%'; 
    } else if (chores >= 10) {
        return '60%'; 
    } else {
        return '74%'; 
    }
}


getDataImperium(){

    this._spinnerService.loading();
    this.mainHTTPService.GetPaymentsByQbe(this.username, this.company).subscribe(resp => {

     if (resp.isSuccessful) {

    if(resp.result.length>0)
    {

      if (resp.result[0].rus_esta == 'I') {
     
           this._spinnerService.close();
 this.messagesService.WarningsS("Usuario Inactivo no puede ingresar a Imperium");

      return
      }
      else{
       this._spinnerService.close();
        this.pageImperium();
      }

    }
    else{
           this._spinnerService.close();
       this.messagesService.WarningsS("Usuario no relacionado");
       return
    }
      }
      else {

         this.messagesService.error(resp.errorMessage);
       return
      }
    });



}

pageImperium()
{


  
  this._spinnerService.loading();
  const page: Page = {
    codProg: "Imperium",
    name: "Imperium",
    idForm: null,
    id: 444,
    url: null,
    cambiarUrl: true,
    lisnk:this.Linkdata,
    // typeForm: itemObj.url.includes('adpro') ? 'adpro' : 'maestro'
    typeForm: 'maestro',
    
               
  };
 
// /#/home?user=1212121212&system=SEVEN&type=bearer&name=authorization&value=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfb
this.token = this.auth.getAuthFromLocalStorage().accessToken;
    const urImperium =this.config.config.urImperium+"/#/home?user="+this.usercode+"&system=SEVEN&type=bearer&name=authorization&value="+this.token;

    this.pagesSe.length = 0;
// alert(urlayudaenlinea)
  this.pagesSe.push({
    codProg: "Imperium",
    name: "Imperium",
    idForm: null,
    id: 444,
    url: urImperium,
    cambiarUrl: true,
    lisnk:this.Linkdata,
    // typeForm: itemObj.url.includes('adpro') ? 'adpro' : 'maestro'
    typeForm: 'maestro',
  })

  // this.removeClass('open-item');


  setTimeout(() => {
    this._spinnerService.close();
  }, 5000);

    page.url=urImperium;

     this._commonService.setItemsessionStorage('Pages', this.pagesSe);
    // this.router.navigate(['/pageTabPanel']);
    // this.addHistorial(page);
    this._pageService.generarPage(page);
    this.closeEmit();
}

closeEmit() {
  this.closet.emit(1);
}
handleOutsideClick(event: MouseEvent) {
  const panel = document.getElementById('sp_offcanvas_toolbar_quick_actionsM');

  if (panel && !panel.contains(event.target as Node)) {
    this.closemas();
  }
}
handleOutsideClickFav() {
  this.isSidebarCollapsedFavorito = false;
}
handleOutsideClickRecent() {
  this.isSidebarCollapsedRecent = false;
}
}

